var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loader"}},[_c('img',{attrs:{"src":"/loading.png","alt":"loading"}}),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }